import { ButtonSizeType } from "../types";

type SelectSizeStyles = {
  height: string;
  padding: string;
  fontSize: string;
};

const sizeStyles: Record<ButtonSizeType, SelectSizeStyles> = {
  xs: {
    height: "2rem",
    padding: "0 var(--spacing-sm)",
    fontSize: "var(--font-size-2xs)",
  },
  sm: {
    height: "2.5rem",
    padding: "0 var(--spacing-md)",
    fontSize: "var(--font-size-xs)",
  },
  md: {
    height: "3rem",
    padding: "0 var(--spacing-md)",
    fontSize: "var(--font-size-sm)",
  },
  lg: {
    height: "3.5rem",
    padding: "0 var(--spacing-lg)",
    fontSize: "var(--font-size-sm)",
  },
};

export default function getSelectSizeStyles(
  size?: ButtonSizeType,
): SelectSizeStyles {
  return sizeStyles[size || "md"];
}
